export const disableAgriculture = () => {
  const today = new Date().toISOString().split('T')[0];
  const unavailableDates = ['2023-11-22', '2023-12-11', '2023-12-13', '2023-12-18', '2024-01-02', '2024-01-26'];

  return unavailableDates.includes(today);
};
